import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { authActions } from 'redux/auth';

export const useHeader = () => {
  const { t } = useTranslation('header');
  const dispatch = useDispatch();

  const [isVisibleAccountMenu, setIsVisibleAccountMenu] = useState(false);

  const onToggleAccountMenu = () => setIsVisibleAccountMenu(state => !state);

  const onClickLogout = () => {
    dispatch(authActions.logout(true));
  };

  /**
   * ローカルストレージの中身をすべてクリアしてログアウトする関数
   */
  const onClickLogoutAndClearStorge = async () => {
    dispatch(authActions.logout(true));
    localStorage.clear();
  };

  return {
    t,
    isVisibleAccountMenu,
    setIsVisibleAccountMenu,
    onToggleAccountMenu,
    onClickLogout,
    onClickLogoutAndClearStorge,
  };
};
